import { motion } from "framer-motion";
import { TrendingUp, Shield, MessageSquare, Layers, Target, Building2 } from "lucide-react";
import ApplyCta from "./ApplyCta";

const benefits = [
  { icon: TrendingUp, text: "Mayor percepción de valor en el mercado." },
  { icon: Shield, text: "Capacidad real de sostener valor percibido (mayor precio)." },
  { icon: MessageSquare, text: "Coherencia total en comunicación y percepción." },
  { icon: Layers, text: "Arquitectura preparada para escalar." },
  { icon: Target, text: "Reducción del riesgo de dilución de marca." },
  { icon: Building2, text: "Identidad estructural para crecer o diversificar." },
];

const stats = [
  { value: "15% – 35%", label: "mayor capacidad de sostener precios." },
  { value: "Hasta 60%", label: "menos decisiones improvisadas." },
  { value: "20% – 50%", label: "mayor coherencia percibida." },
  { value: "Hasta 40%", label: "más agilidad en lanzamientos." },
  { value: "5 a 10 años", label: "de vigencia estructural de marca." },
];

const KeyBenefits = () => {
  return (
    <section id="beneficios-clave"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, hsl(215 48% 20%), hsl(217 61% 10%))" }}
    >
      <div
        className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full blur-3xl opacity-10"
        style={{ backgroundColor: "hsl(216 32% 52%)" }}
      />

      <div className="container px-4 relative z-10">
        {/* Benefits */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-1.5 rounded-full border border-[hsl(216_32%_52%/0.4)] bg-[hsl(216_32%_52%/0.1)] text-white text-sm font-medium tracking-widest mb-6">
            BENEFICIOS CLAVE
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            Con BrandWay©, tu empresa obtiene:
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto mb-24">
          {benefits.map((benefit, index) => (
            <motion.div
              key={benefit.text}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.08 }}
              className="flex items-start gap-4 p-6 rounded-2xl border border-white/10 bg-white/5"
            >
              <benefit.icon className="w-5 h-5 text-[hsl(216_35%_75%)] mt-0.5 flex-shrink-0" />
              <p className="text-white/80 leading-relaxed">{benefit.text}</p>
            </motion.div>
          ))}
        </div>

        {/* Results */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <h3 className="font-display text-2xl md:text-3xl font-bold text-white mb-3">
            Resultados Observados en marcas desarrolladas
          </h3>
          <p className="text-white/60 text-lg max-w-2xl mx-auto">
            Cuando una empresa reestructura estratégicamente su marca, suelen observarse:
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 max-w-5xl mx-auto mb-12">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.08 }}
              className="text-center"
            >
              <div
                className="text-2xl md:text-3xl font-bold mb-2 bg-clip-text text-transparent"
                style={{ backgroundImage: "linear-gradient(135deg, #60a5fa 0%, #93c5fd 100%)" }}
              >
                {stat.value}
              </div>
              <p className="text-white/60 text-sm leading-relaxed">{stat.label}</p>
            </motion.div>
          ))}
        </div>

        {/* Disclaimer */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center text-white/40 text-sm max-w-2xl mx-auto italic"
        >
          No son promesas comerciales.
          <br />
          Son consecuencias habituales de una arquitectura estratégica sólida.
        </motion.p>

        <ApplyCta variant="dark" />
      </div>
    </section>
  );
};

export default KeyBenefits;
